var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "map-btn-menu map-shadow map-top-item",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "menu-title" },
        [
          _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
          _c(
            "v-icon",
            {
              staticClass: "menu-close",
              attrs: { color: "white" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v("icon-close")]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.options_length
        ? [
            _c("div", { staticClass: "menu-list" }, [
              _c("label", [
                _c(
                  "span",
                  [
                    _vm._t("empty-msg", function() {
                      return [_vm._v("--- 無可調整項目 ---")]
                    })
                  ],
                  2
                )
              ])
            ])
          ]
        : _vm.input_type == "basemap_boundary"
          ? _vm._l(_vm.option_data, function(option_item, option_item_key) {
              return _c(
                "div",
                { key: option_item_key, staticClass: "menu-list" },
                [
                  _c(
                    "div",
                    { staticClass: "menu-list__subtitle d-flex aligh-center" },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v(
                          _vm._s(
                            option_item.subtitle.icon == "basemap"
                              ? "icon-selected-data-setting-2"
                              : "icon-geographic-info"
                          )
                        )
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(option_item.subtitle.name) +
                          "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(option_item.list, function(options, key) {
                    return _c(
                      "label",
                      { key: key, staticClass: "menu-list__label" },
                      [
                        option_item_key == 0
                          ? [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected[0],
                                    expression: "selected[0]"
                                  }
                                ],
                                attrs: { name: _vm.name, type: "checkbox" },
                                domProps: {
                                  value: options.name,
                                  checked: Array.isArray(_vm.selected[0])
                                    ? _vm._i(_vm.selected[0], options.name) > -1
                                    : _vm.selected[0]
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.selected[0],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = options.name,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selected,
                                              0,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selected,
                                              0,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.selected, 0, $$c)
                                      }
                                    },
                                    function($event) {
                                      return _vm.$emit(
                                        "change_boundary",
                                        _vm.selected[0],
                                        options.name,
                                        $event.target.checked
                                      )
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                class: [
                                  {
                                    checked: _vm.selected[0].includes(
                                      options.name
                                    )
                                  },
                                  "checkbox"
                                ]
                              })
                            ]
                          : [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected[1],
                                    expression: "selected[1]"
                                  }
                                ],
                                attrs: { name: _vm.name, type: "radio" },
                                domProps: {
                                  value: options.name,
                                  checked: _vm._q(_vm.selected[1], options.name)
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      return _vm.$set(
                                        _vm.selected,
                                        1,
                                        options.name
                                      )
                                    },
                                    function($event) {
                                      return _vm.$emit(
                                        "change_basemap",
                                        _vm.selected[1]
                                      )
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                class: [
                                  { checked: _vm.selected[1] === options.name },
                                  "radio"
                                ]
                              })
                            ],
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(options.text))])
                      ],
                      2
                    )
                  })
                ],
                2
              )
            })
          : _vm.input_type == "radio"
            ? [
                _c(
                  "div",
                  { staticClass: "menu-list" },
                  _vm._l(_vm.option_data, function(options, key) {
                    return _c("label", { key: key }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selected,
                            expression: "selected"
                          }
                        ],
                        attrs: { name: _vm.name, type: "radio" },
                        domProps: {
                          value: options.name,
                          checked: _vm._q(_vm.selected, options.name)
                        },
                        on: {
                          change: [
                            function($event) {
                              _vm.selected = options.name
                            },
                            function($event) {
                              return _vm.$emit("change", _vm.selected)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(options.text))])
                    ])
                  }),
                  0
                )
              ]
            : _vm.input_type == "checkbox"
              ? [
                  _c(
                    "div",
                    { staticClass: "menu-list" },
                    _vm._l(_vm.option_data, function(options, key) {
                      return _c("label", { key: key }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selected,
                              expression: "selected"
                            }
                          ],
                          attrs: { name: _vm.name, type: "checkbox" },
                          domProps: {
                            value: options.name,
                            checked: Array.isArray(_vm.selected)
                              ? _vm._i(_vm.selected, options.name) > -1
                              : _vm.selected
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.selected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = options.name,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selected = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selected = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selected = $$c
                                }
                              },
                              function($event) {
                                return _vm.$emit(
                                  "change",
                                  _vm.selected,
                                  options.name,
                                  $event.target.checked
                                )
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(options.text))])
                      ])
                    }),
                    0
                  )
                ]
              : _vm.input_type == "dragable"
                ? [
                    _c(
                      "draggable",
                      {
                        staticClass: "menu-list draggable-list",
                        on: {
                          change: function($event) {
                            return _vm.$emit(
                              "change",
                              _vm.options_name_list,
                              $event.moved
                            )
                          }
                        },
                        model: {
                          value: _vm.option_data,
                          callback: function($$v) {
                            _vm.option_data = $$v
                          },
                          expression: "option_data"
                        }
                      },
                      _vm._l(_vm.option_data, function(options, key) {
                        return _c(
                          "label",
                          {
                            key: key,
                            attrs: { title: "上下拖動可調整圖層順序" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(options.text) +
                                  "\n                    "
                              ),
                              _c("span", { staticClass: "menu-order" }, [
                                _vm._v(_vm._s(key + 1))
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                : _vm.input_type == "range"
                  ? [
                      _c(
                        "div",
                        { staticClass: "menu-list" },
                        _vm._l(_vm.option_data, function(options, key) {
                          return _c("label", { key: key }, [
                            _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(options.text) +
                                  "\n            "
                              ),
                              _c("span", { staticClass: "menu-range" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.values[options.name],
                                      expression: "values[options.name]"
                                    }
                                  ],
                                  attrs: {
                                    name: "name",
                                    type: "range",
                                    min: "0",
                                    max: "1",
                                    step: "0.1"
                                  },
                                  domProps: { value: _vm.values[options.name] },
                                  on: {
                                    change: function($event) {
                                      return _vm.$emit(
                                        "change",
                                        options.name,
                                        $event.target.value
                                      )
                                    },
                                    __r: function($event) {
                                      return _vm.$set(
                                        _vm.values,
                                        options.name,
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    style: { opacity: _vm.values[options.name] }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.values[options.name] * 100) +
                                        "%\n                "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }